<template>
  <div>
    <vx-card class="org-card">
      <div>
        <h3 class="mb-base">
          <span class="text-primary">{{ orgData.name }}</span> Admins
        </h3>
        <div class="my-base-large">
          <h5 class="mb-3">Add Admin</h5>
          <div class="mb-3">
            <vs-input v-validate="'required|email|min:3'" data-vv-validate-on="blur" :disabled="!isUserLoggedIn"
              name="Email" placeholder="Email Address" icon-no-border icon="icon icon-mail" icon-pack="feather"
              v-model="email" class="w-full lg:w-1/2" @keyup="adminExists()" />
            <span v-if="adminAlreadyExists" class="text-danger text-sm">Admin already exists</span>
            <span v-else class="text-danger text-sm">{{
              errors.first("Email")
            }}</span>
          </div>
          <vs-button class="invite-btn" :disabled="adminAlreadyExists || !validEmail" @click.stop="inviteAdmin()">Send
            Invite</vs-button>
        </div>
        <div v-if="orgData && orgData.admin && orgData.subAdmins">
          <h5 class="mb-3">Admins</h5>
          <vs-table max-items="7" pagination :data="subAdmins">
            <template slot="thead">
              <vs-th> Email </vs-th>
              <vs-th> Name </vs-th>
              <vs-th> Max Role </vs-th>
              <vs-th> Status </vs-th>

              <vs-th> Revoke Access </vs-th>
            </template>

            <template>
              <vs-tr v-if="orgData && orgData.admin" key="super-admin-data">
                <vs-td :data="orgData.admin.email">
                  <vs-row vs-align="center">
                    <div class="float-leftt mr-3">
                      {{ orgData.admin.email }}
                    </div>
                    <!-- <vs-chip color="primary" v-if="userData.email === orgData.admin.email">It's you</vs-chip> -->
                  </vs-row>
                </vs-td>

                <vs-td v-if="orgData.admin.firstName" :data="orgData.admin.firstName">
                  {{ orgData.admin.firstName }} {{ orgData.admin.lastName }}
                </vs-td>
                <vs-td v-else></vs-td>

                <vs-td data="Super Admin">
                  <small>Super Admin</small>
                </vs-td>

                <vs-td data="Active">
                  <vs-chip color="success">Active</vs-chip>
                </vs-td>

                <vs-td data="Super admin cannot be removed">
                  <small>Super admin cannot be removed</small>
                </vs-td>
              </vs-tr>

              <vs-tr v-for="(tr, indextr) in subAdmins" :key="indextr">
                <vs-td :data="tr.email">
                  {{ tr.email }}
                </vs-td>

                <vs-td v-if="
                  tr.userData && tr.userData[0] && tr.userData[0].firstName
                " :data="tr.userData[0].firstName">
                  {{ tr.userData[0].firstName }}
                  {{ tr.userData[0].lastName }}
                </vs-td>
                <vs-td v-else></vs-td>

                <vs-td data="Sub-Admin">
                  <small>Sub-Admin</small>
                </vs-td>

                <vs-td :data="tr.status">
                  <vs-chip v-if="tr.status === 'active'" color="success">Active</vs-chip>
                  <vs-chip v-else color="danger">Pending</vs-chip>
                </vs-td>

                <vs-td>
                  <vs-button color="danger" size="small" @click.stop="revokeSubAdmin(tr._id)">Revoke</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      adminAlreadyExists: false,
      // isCurrentUserSubAdmin: true,
    };
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    subAdmins() {
      if (this.orgData) return this.orgData.subAdmins;
      return [];
    },
    validEmail() {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.email).toLowerCase());
    },
    // isCurrentUserSubAdmin() {
    //   if(!(this.orgData && this.orgData._id)) return true;
    //   else if(this.orgData.subAdmins && this.orgData.subAdmins.findIndex(sa => sa.email === this.userData.email) !== -1) return true;
    //   return false;
    // }
    isCurrentUserSubAdmin() {
      if (this.userData && this.orgData && this.orgData.admin) {
        return this.userData._id !== this.orgData.admin._id;
      }
      return true;
    },
  },
  methods: {
    adminExists() {
      if (this.email.toLowerCase() === this.userData.email.toLowerCase()) {
        this.adminAlreadyExists = true;
      } else {
        this.$store
          .dispatch("organization/fetchOrganizationAdminByEmail", {
            email: this.email.toLowerCase(),
            organizationId: this.organizationId,
          })
          .then((res) => {
            if (res.data.total > 0) {
              this.adminAlreadyExists = true;
            } else {
              this.adminAlreadyExists = false;
            }
          });
      }
    },
    inviteAdmin() {
      if (this.subAdmins.find(e => e.email == this.email.toLowerCase())) {
        this.adminAlreadyExists = true;
        return;
      }
      this.$vs.loading();
      const payload = {
        email: this.email
          ? this.email.toLowerCase()
          : "unexpectederror@getboarded.tech",
        status: false,
        organizationId: this.organizationId,
        maxRole: "sub-admin",
        organizationName: this.orgData.name,
      };

      this.$store
        .dispatch("organization/inviteOrganizationAdmin", payload)
        .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Add Sub-Admin to Organization, Invitation Sent",
            color: "primary",
          });
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title:
              "Add Sub-Admin to Organization, Invitation could not be sent",
            color: "danger",
          });
          throw err;
        });

      this.email = null;
    },
    revokeSubAdmin(orgSubAdminId) {
      this.$store
        .dispatch("organization/revokeSubAdmin", { orgSubAdminId })
        .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sub-Admin access revoked.",
            color: "primary",
          });
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Cannot revoke Sub-Admin access",
            color: "danger",
          });
          throw err;
        });
    },
  },
};
</script>

<style scoped>
.my-base-large {
  margin: 3rem auto 4rem auto;
}

.invite-btn {
  border-radius: 4px;
}

.vs-con-table>>>.vs-table--not-data {
  display: none !important;
}
</style>
